import { NavDropdownProps } from './_NavDropdown';
import { isNavDropdown, SecondaryNavProps } from './_SecondaryNav';
import { Anchor } from '@repo/ui/src/components/Anchor';
import ChevronIcon from '@repo/ui/src/components/Icons/ChevronIcon';
import { navigationClicked } from '@repo/ui/src/services/analytics';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

export interface MobileSecondaryNavProps extends SecondaryNavProps {
  activeDropdown: NavDropdownProps | null;
  setActiveDropdown: StateSetterFunction<NavDropdownProps | null>;
}

const MobileSecondaryNav = ({
  items,
  activeDropdown,
  setActiveDropdown,
  primaryHeader,
}: MobileSecondaryNavProps) => {
  return (
    <div role="region" aria-label={`${primaryHeader} submenu`}>
      <ul
        className={classNames('list-none grid gap-x-8 sm:flex sm:justify-center px-0')}
        aria-label="main"
      >
        {items?.map((item, i) => {
          const hasDropdown = isNavDropdown(item);
          return (
            <li key={i} className="px-4 sm:px-0">
              {!hasDropdown ? (
                <Anchor
                  {...item}
                  className={classNames(
                    'inline-block tra-text-web-body-l hover:text-brand-400 hover:underline transition-all duration-300 py-6',
                  )}
                  onClick={() =>
                    navigationClicked({
                      nav_type: 'Top Navigation',
                      clicked_text: item?.displayName ?? '',
                      primary_header: primaryHeader ?? '',
                      secondary_header: item?.displayName ?? '',
                    })
                  }
                />
              ) : (
                <button
                  onClick={() => {
                    setActiveDropdown(item);
                    navigationClicked({
                      nav_type: 'Top Navigation',
                      clicked_text: item?.title ?? '',
                      primary_header: primaryHeader ?? '',
                      secondary_header: item?.title ?? '',
                    });
                  }}
                  className={classNames(
                    'tra-text-web-body-l flex justify-between w-full sm:w-auto sm:block hover:text-brand-400 hover:underline transition-all duration-300 py-6',
                  )}
                  aria-expanded={activeDropdown === item}
                  aria-haspopup="true"
                  aria-controls="mobile-tertiary-nav"
                >
                  {item.title}
                  <span className="w-6 inline-block sm:hidden" aria-hidden="true">
                    <ChevronIcon direction="right" />
                  </span>
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default MobileSecondaryNav;
